import { isFuturesFamilySymbol } from './normalizeChartCandles';

/**
 * normalizeChartCandles' minute-bucketing anchor (buildMinuteAnchorContext) requires
 * sessionWindows for futures symbols on any duration >1 minute — without it, buckets fall back to
 * a midnight-ET grid that's mis-anchored vs the real session open (see buildMinuteAnchorContext's
 * futures branch in normalizeChartCandles.js). Equities always use a fixed 9:30 anchor and never
 * need sessionWindows; a duration of 1 minute is never re-bucketed (bucketCandleTimeStamp returns
 * the raw timestamp), so it needs no anchor either.
 */
export function computeNeedsSessionWindows(symbol, timeUnit, candleDuration) {
  return (
    isFuturesFamilySymbol(symbol) &&
    String(timeUnit).toUpperCase() === 'MINUTES' &&
    Number(candleDuration) > 1
  );
}

/**
 * sessionWindows can legitimately come back empty forever (GetChart.buildSessionWindows returns
 * [] when there are no candles yet, or no session data matches the visible dates — holiday, data
 * gap, brand-new symbol). Waiting on it unconditionally would replace "briefly shows a
 * mis-anchored chart" with "shows nothing, ever" for those cases, which is worse than the bug
 * being fixed. graceExpired caps the wait so a chart always eventually renders on whatever anchor
 * is available once the true seed data has had a reasonable chance to arrive.
 */
export function isSessionWindowsReady({ needsSessionWindows, sessionWindows, graceExpired }) {
  if (!needsSessionWindows) {
    return true;
  }
  if (graceExpired) {
    return true;
  }
  return Array.isArray(sessionWindows) && sessionWindows.length > 0;
}
